import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { InputNumberProps } from 'antd';
import { Button, InputNumber } from 'antd';
import './PageNumberControls.less';
import { isNumber } from 'lodash';

interface Props {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const PageNumberControls: React.FC<Props> = ({ currentPage, totalPages, onPageChange }: Props) => {
    const ref = React.useRef<HTMLInputElement>(null);

    const onChange: InputNumberProps['onChange'] = value => {
        if (isNumber(value) && value >= 1 && value <= totalPages) {
            onPageChange(value);
        }
    };

    const onPressEnter = () => {
        ref.current?.blur();
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    return (
        <div className="page-number-controls">
            <Button size="small" onClick={handlePrevious} type="link" disabled={currentPage <= 1}>
                <i className={`alpha-icon sm pagination-arrow-left ${currentPage <= 1 ? 'inactive' : ''}`} />
            </Button>
            <InputNumber
                ref={ref}
                min={1}
                max={totalPages}
                value={currentPage}
                onChange={onChange}
                onPressEnter={onPressEnter}
            />
            <span>/</span>
            <span>{totalPages}</span>
            <Button
                size="small"
                onClick={handleNext}
                type="link"
                style={{ marginLeft: '0px' }}
                disabled={currentPage >= totalPages}
            >
                <i className={`alpha-icon sm pagination-arrow-right ${currentPage >= totalPages ? 'inactive' : ''}`} />
            </Button>
        </div>
    );
};

export default observer(PageNumberControls);
